<!--首页-->
<template>
	<div class="id">
		<h3 style="padding-top: 60px;">{{ $t('创建GPT账户') }}</h3>
		<h5 style="color: #7e7e7e">
			{{ $t('使用您的电子邮箱进行注册') }}
		</h5>
		<!-- <div class="title"> {{ $t('邮箱') }}</div> -->
		<div class="account">{{ $t('邮箱') }}</div>
		<van-field v-model="mail" :placeholder="$t('请输入账号')" />
		<!-- <div class="account">{{ $t('验证码') }}</div>
		<van-field v-model="captcha" center clearable :placeholder="$t('请输入验证码')">
			<template #button>
				<van-button size="mini" type="primary" @click="btnCode">{{ $t('发送验证码') }}</van-button>
			</template>
		</van-field> -->

		<div class="account">{{ $t('密码') }}</div>
		<van-field v-model="password" type="password" :placeholder="$t('请输入密码')" />
		<div class="account">{{ $t('确认密码') }}</div>
		<van-field v-model="passwordS" type="password" :placeholder="$t('确认密码')" />
		<div class="account">{{ $t('资金密码') }}</div>
		<van-field v-model="pay_password" type="password" :placeholder="$t('请输入资金密码')" />
		<div class="account">{{ $t('确认资金密码') }}</div>
		<van-field v-model="pay_passwordS" type="password" :placeholder="$t('请再次输入资金密码')" />
		<div class="account">{{ $t('邀请码(选填)') }}</div>
		<van-field v-model="code" :placeholder="$t('邀请码(选填)')" />
		<div style="display: flex;align-items: center;">
			<van-checkbox v-model="checked" shape="square" class="van-checkbox" icon-size="14">
			</van-checkbox>
			<div style="padding-left: 10px;font-size: 14px;color: #999;">{{ $t('我已阅读同意') }} GPT</div>
			<div style="padding-left: 10px;font-size: 14px;color: rgb(0, 240, 255);"
				@click="$router.push('/mobile/forget')">{{
					$t('服务条款') }}</div>
		</div>
		<div class="btn" @click="register">{{ $t('注册') }}</div>
		<div class="register" @click="$router.push('/mobile/login')">{{ $t('登陆') }}</div>
	</div>
</template>
<script>
import {
	post
} from '@/http/request'

export default {
	components: {},
	data() {
		return {
			mail: '',
			password: '',
			passwordS: '',
			pay_password: '',
			pay_passwordS: '',
			code: '',
			checked: false,
			captcha: ''
		};
	},
	mounted() {
		this.code = this.$route.params.invite_code || ''
	},
	beforeUnmount() { },
	methods: {
		btnCode() {
			post(this.$apis.emsSend, {
				email: this.mail
			}).then(res => {
				if (res.code == 1) {
					this.$toast(res.msg)
				}
			})

		},
		register() {
			if (this.passwordS != this.password) {
				this.$notify.error(this.$t('两次密码不一致'));
				return
			}
			if (this.pay_passwordS != this.pay_password) {
				this.$notify.error(this.$t('两次密码不一致'));
				return
			}
			if (!this.checked) {
				this.$notify.error(this.$t('请勾选协议'));
				return
			}
			post(this.$apis.register, {
				account: this.mail,
				password: this.password,
				invite_code: this.code,
				captcha: this.captcha,
				pay_password: this.pay_password
			}).then(res => {
				if (res.code == 1) {
					this.$store.commit('setUserInfo', res.data.userinfo)
					this.$store.commit('setToken', res.data.userinfo.token)
					this.$notify.success(res.msg)
					// 延时跳转，让用户看到提示
					setTimeout(() => {
						this.$nav.go('/mobile/home')
					}, 800)
				}
			})
		}

	},
};
</script>
<style lang="less" scoped>
.id {
	color: #fff;
	padding: 20px;

	.van-cell {
		background-color: #000 !important;
		border: 1px solid #3e444c;
		color: #3e444c !important;
	}

	.van-cell::after {
		border-bottom: 0px solid #000;
	}

	::v-deep .van-field__control {
		color: #fff !important;
	}

	.title {
		display: inline-block;
		background-color: #00f0ff;
		padding: 10px 20px;
		border-radius: 10px;
		font-size: 14px;
		margin-top: 20px;
		color: #000;
	}

	.account {
		padding-top: 20px;
		padding-bottom: 10px;
	}

	.van-checkbox {
		padding: 20px 0;
		font-size: 16px;
	}

	::v-deep .van-checkbox__label {
		margin-left: 26px !important;
		font-size: 26px;
	}

	.btn {
		cursor: pointer;
		color: #000;
		background-color: #00f0ff;
		text-align: center;
		padding: 10px 0;
		border-radius: 6px;
		margin-bottom: 20px;
	}

	.register {
		color: #00f0ff;
	}

	.forget {
		color: #00f0ff;
		padding-top: 20px;
	}

}
</style>